import { Navigate, Route, Routes } from "react-router-dom";
import { useAuth } from "./hooks/useAuth";
import { AuthContext } from "./hooks/AuthContext";
import { Layout } from "./components/Layout";
import { Login } from "./pages/Login";
import { Dashboard } from "./pages/Dashboard";
import { Browse } from "./pages/Browse";
import { CoffeeDetail } from "./pages/CoffeeDetail";
import { AddCoffee } from "./pages/AddCoffee";
import { PrintLabel } from "./pages/PrintLabel";
import { LabelSheet } from "./pages/LabelSheet";
import { Stocktake } from "./pages/Stocktake";
import { Stats } from "./pages/Stats";
import { Roasters } from "./pages/Roasters";
import { Drippers } from "./pages/Drippers";
import { Grinders } from "./pages/Grinders";
import { CafeLog } from "./pages/CafeLog";
import { CafeLogEntry } from "./pages/CafeLogEntry";
import { Account } from "./pages/Account";
import { AdminUsers } from "./pages/AdminUsers";

export default function App() {
  const auth = useAuth();

  if (auth.state === "loading") {
    return <div className="min-h-screen flex items-center justify-center text-paper-600">Loading…</div>;
  }

  if (auth.state === "anon") {
    return (
      <Routes>
        <Route path="/login" element={<Login onAuthed={auth.setAuthed} />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    );
  }

  const isAdmin = !!auth.me?.is_admin;

  return (
    <AuthContext.Provider value={{ me: auth.me, logout: auth.logout }}>
      <Routes>
        <Route path="/print/:id" element={<PrintLabel />} />
        <Route
          path="*"
          element={
            <Layout>
              <Routes>
                <Route path="/" element={<Dashboard />} />
                <Route path="/browse" element={<Browse />} />
                <Route path="/add" element={<AddCoffee />} />
                <Route path="/labels" element={<LabelSheet />} />
                <Route path="/roasters" element={<Roasters />} />
                <Route path="/drippers" element={<Drippers />} />
                <Route path="/grinders" element={<Grinders />} />
                <Route path="/stocktake" element={<Stocktake />} />
                <Route path="/stats" element={<Stats />} />
                <Route path="/cafe" element={<CafeLog />} />
                <Route path="/cafe/new" element={<CafeLogEntry />} />
                <Route path="/cafe/:id" element={<CafeLogEntry />} />
                <Route path="/coffee/:id" element={<CoffeeDetail />} />
                <Route path="/account" element={<Account />} />
                <Route path="/admin/users" element={isAdmin ? <AdminUsers /> : <Navigate to="/" replace />} />
                <Route path="/login" element={<Navigate to="/" replace />} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </Layout>
          }
        />
      </Routes>
    </AuthContext.Provider>
  );
}
